export const SAVE_CONTROL_REPO_START = 'SAVE_CONTROL_REPO_START';
export const SAVE_CONTROL_REPO_COMPLETE = 'SAVE_CONTROL_REPO_COMPLETE';
export const SAVE_CONTROL_REPO_ERROR = 'SAVE_CONTROL_REPO_ERROR';
export const SAVE_CONTROL_REPO_WEBHOOK_ERROR =
  'SAVE_CONTROL_REPO_WEBHOOK_ERROR';
export const CREATE_MAIN_BRANCH = 'CREATE_MAIN_BRANCH';
export const CLOSE_MODAL = 'CLOSE_MODAL';
